var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightUpRed(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "#FF3C26",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67188 0.00683594C10.0527 0.00683594 10.375 0.329102 10.375 0.709961V7.74121C10.375 8.15137 10.0527 8.44434 9.67188 8.44434C9.26172 8.44434 8.96875 8.15137 8.96875 7.74121V2.40918L2.20117 9.17676C1.9082 9.46973 1.46875 9.46973 1.20508 9.17676C0.912109 8.91309 0.912109 8.47363 1.20508 8.20996L7.97266 1.44238H2.64062C2.23047 1.44238 1.9375 1.12012 1.9375 0.739258C1.9375 0.329102 2.23047 0.0361328 2.64062 0.0361328H9.67188V0.00683594Z",
    fill: "#FF3C26"
  })));
}
export default SvgArrowRightUpRed;